import {CardText, CardActions} from "material-ui/Card"
import {Toolbar, ToolbarGroup, ToolbarTitle} from "material-ui/Toolbar"
import {containers} from "@swarm2/core"
import Button from "material-ui/RaisedButton"
import React from "react"
import SubmitIcon from "material-ui/svg-icons/action/help-outline"
import TextField from "material-ui/TextField"
import _ from "lodash"
import {withRouter} from "react-router-dom"

import * as Util from "../common"
import _Error from "./Error"

const M = Util.intlMessages("view.ConfirmResetPasswordView")
const EM = Util.intlMessages("view.ConfirmResetPasswordView.error")
const Error = _Error(EM)

function ConfirmResetPasswordRender(props) {
  if (props.isError) return <Util.Error error={props} />
  const {input, formErrors} = props
  return (
    <div>
      <form
        onSubmit={
          props.isSubmitAllowed ? props.submit : e => e.preventDefault()
        }
      >
        <Toolbar>
          <ToolbarGroup>
            <ToolbarTitle text={<M id="title" />} />
          </ToolbarGroup>
        </Toolbar>
        <CardText>
          <p>
            <M id="description" />
          </p>
          <div>
            <TextField
              name="password"
              floatingLabelText={<M id="field.password" />}
              type="password"
              value={props.password}
              onChange={input.setPassword}
            />
          </div>
          <div>
            <TextField
              name="password2"
              floatingLabelText={<M id="field.password2" />}
              type="password"
              value={props.password2}
              onChange={input.setPassword2}
            />
          </div>
          <div>
            <TextField
              name="errors"
              underlineShow={false}
              disabled={true}
              errorText={formErrors.map((error, i) => (
                <Error key={i} error={error} />
              ))}
            />
          </div>
        </CardText>
        <CardActions>
          <Button
            primary
            label={<M id="submit" />}
            type="submit"
            icon={<SubmitIcon />}
            disabled={!props.isSubmitAllowed}
            onClick={props.submit}
          />
        </CardActions>
        <CardText>
          {props.request.state === "SUCCESS" ? <M id="success" /> : null}
        </CardText>
      </form>
    </div>
  )
}
export default _.flowRight(
  containers.authSignin.ConfirmResetPassword(),
  withRouter,
  containers.willReceiveProps(props => {
    if (props.request.state === "SUCCESS") {
      props.history.push("/auth/login")
    }
  }),
  Util.DumpProps,
)(ConfirmResetPasswordRender)



// WEBPACK FOOTER //
// ./src/auth-signin/ConfirmResetPasswordView.js